import React from "react";

import { PageLoader, Typography } from "clearsense-ui/components";

import AnimatedChart from "./AnimatedChart";
import { SUMMARY_PARAMETERS } from "./constants";

const ModelQualitySummary = ({ data, isLoading }) => (
  <div className="flex flex-col w-full bg-white dark:bg-gray-800 border-2 lg:col-span-2 h-[500px] lg:h-72 xl:h-72">
    <div className="flex-none px-6 py-4 border-b-2">
      <Typography style="h3" type="semibold">
        Model Quality Summary
      </Typography>
    </div>

    {isLoading ? (
      <div className="flex-1">
        <PageLoader />
      </div>
    ) : data?.derived_metrics ? (
      <div className="grid h-full grid-cols-2 gap-2 my-5 lg:grid-cols-4 xl:grid-cols-4">
        {SUMMARY_PARAMETERS.map(({ parameter, accessor }) => (
          <AnimatedChart
            key={accessor}
            value={data.derived_metrics[accessor]}
            parameter={parameter}
          />
        ))}
      </div>
    ) : (
      <div className="flex items-center justify-center flex-1">
        <Typography>Failed to load data</Typography>
      </div>
    )}
  </div>
);

export default ModelQualitySummary;
